var request = require('superagent');
var data = {};

module.exports = function(apibase) {
    return function(key, cb) {
        if( !data[key] ) {
            request
                .get(apibase + key)
                .end(function(err, res) {
                    if( !err ) {
                        data[key] = res.text;
                    }
                    else {
                        data[key] = false;
                    }

                    cb(data[key]);
                });
        }
        else {
            cb(data[key]);
        }
    };
};


// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/getdata.js